
import type { PerformanceMetrics } from '@/types/analytics';

/**
 * Centralized store for performance metrics
 */
export class PerformanceMetricsStore {
  private metrics: PerformanceMetrics = {};
  
  /**
   * Update metrics with new values
   */
  updateMetrics(newMetrics: Partial<PerformanceMetrics>): void {
    this.metrics = { ...this.metrics, ...newMetrics };
  }
  
  /**
   * Get a copy of all current metrics
   */
  getAllMetrics(): PerformanceMetrics {
    return { ...this.metrics };
  }
  
  /**
   * Add to the cumulative layout shift value
   */
  addCumulativeLayoutShift(value: number): void {
    if (!this.metrics.cumulativeLayoutShift) {
      this.metrics.cumulativeLayoutShift = 0;
    }
    this.metrics.cumulativeLayoutShift += value;
  }
  
  /**
   * Add a long task to the metrics
   */
  addLongTask(task: { duration: number, timestamp: number }): void {
    if (!this.metrics.longTasks) {
      this.metrics.longTasks = [];
    }
    this.metrics.longTasks.push(task);
  }
}
